/* eslint-disable react/require-default-props */
import React from 'react';

import AutoComplete from '../autoCompleteCommon';

interface Props {
  value: any;
  onChange: any;
  data: Array<any>;
  label?: string;
  isError?: boolean;
  helperText?: string;
  disabled?: boolean;
}

const SelectAutoComplete: React.FC<Props> = ({
  data,
  onChange,
  value,
  label,
  isError,
  helperText,
  disabled,
}) => (
  <AutoComplete
    value={value || ''}
    label={label || ''}
    data={data}
    limitResult={20}
    onChange={onChange}
    // @ts-ignore
    disabled={disabled || false}
    isError={isError}
    helperText={helperText}
  />
);
export default SelectAutoComplete;
